export const environment = {
  production: true,
  index: 'https://pre-cronicare.ticsmart.eu/',
  authServer: 'https://sso.upm.ticsmart.eu',
  authRealm: 'UPM',
  authClientId: 'cronicare',
};
